import api from '@pray/shared/utils/api';

export const getLeaderSegments = async ({ artistId = '' }) => {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/analytics/periodic-table/segments`;
  const response = await api.executeGetRequest(url);

  return response.data;
};
